import type { FaireProductEntity } from "../../entity_types/product";

export const p_uqt2au3wf8: FaireProductEntity = {
  token: "p_uqt2au3wf8",
  type: "product",
  name: "Beach Teach Teacher Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/1ad6d8d9a78f65783b5b9f000c40b3b61b12ef815831bcae48e2fe7b2d42f588.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/84b45a8b07b3bbed7c86454b63d844df292c57e5f0a0b8e098ee50097e2885b6.jpeg",
    "https://cdn.faire.com/fastly/b49987e02d4eaa412720bc08cac0d70b54b63c4086d50778d001f079a72f64cc.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:51.818Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
